import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { transformDateValue } from 'core/js/FormUtils';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function InventoryitemInfo({inventoryitemObj}){
   // const { inventoryitemObj} = useSelector((state)=>state.manufslice.inventoryitemDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ padding:1,overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'secondary.100'}}
      >
        {inventoryitemObj.orderid!==0?
        <Grid item lg={4} xs={4}><FieldView2 label="Order Id"  value={ inventoryitemObj.orderid }/></Grid>
        :<></>}
        <Grid item lg={4} xs={4}><FieldView2 label="Created By"  value={ inventoryitemObj.createdby }/></Grid>
        <Grid item lg={4} xs={4}><FieldView2 label="Date"  value={ transformDateValue(inventoryitemObj.editTimestamp) }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}